module.exports = "/img/iqos-grey.svg?cbc387c761cd7265f1ec11aac73310de";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/iqos-grey.svg
// module id = FOVk
// module chunks = 83